import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
// Initialize i18n before render so React components have access to t().
// We DO NOT await the resource fetch — `react.useSuspense: false` lets
// the shell render keys (or in-flight defaults) while JSON loads.
import i18n from './i18n';
import { registerSW } from './registerSW';
import { installGlobalErrorHandlers } from './observability/telemetry';
import { initWebVitals } from './observability/webVitals';

// Capture uncaught errors / promise rejections that escape React's render
// boundaries (event handlers, timers, async callbacks) and route them to the
// telemetry sink before anything else runs.
installGlobalErrorHandlers();

/**
 * Sync the `lang` attribute on <html> with the active locale. All currently
 * supported locales are LTR; RTL support (and the direction flip) is deferred
 * until an RTL locale + resource bundle actually ships (see i18n.ts).
 */
function syncHtmlDir(lng: string) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lng;
}

syncHtmlDir(i18n.language || 'en-US');
i18n.on('languageChanged', (lng) => syncHtmlDir(lng));

// Fire-and-forget — never blocks first paint. The SW takes effect on
// the next navigation; production-only by default (see registerSW.ts).
void registerSW();

// Report Core Web Vitals (LCP/CLS/INP/FCP/TTFB) to the telemetry sink. No
// third-party dependency — uses the platform PerformanceObserver API.
initWebVitals();

ReactDOM.createRoot(document.getElementById('root')!).render(
 <React.StrictMode>
 <App />
 </React.StrictMode>
);
